import FragmentTransform from 'ember-data-model-fragments/transforms/fragment';
export default FragmentTransform;
